import { Link } from "react-router-dom";

import "./ComingSoon.css";

/**
 * Holding page for anonymous and not-yet-provisioned visitors. Authenticated
 * users are redirected to their dashboard by RootResolver before they reach
 * this (MER-515).
 *
 * `showSignIn` gates the Sign in link: it helps an anonymous visitor who has
 * access, but for a signed-in-yet-unprovisioned user it is a dead affordance
 * (it would bounce them back here), so RootResolver passes false in that case.
 */
export default function ComingSoon({ showSignIn = true }: { showSignIn?: boolean }) {
  return (
    <main className="coming-soon">
      <section className="coming-soon__card">
        <div className="coming-soon__logo">
          <span className="coming-soon__logo-mark">M</span>
          <span className="coming-soon__logo-text">Meridian Analytics</span>
        </div>
        <span className="coming-soon__pill">Coming soon</span>
        <h1 className="coming-soon__title">Your dashboard is being built.</h1>
        <p className="coming-soon__body">
          The Meridian self-host dashboard is in active build. Seth, Sander, and the AJ team will
          receive sign-in details when the first phase goes live.
        </p>
        {/* MER-515: a logged-out customer who already has access needs a way
            in from the bare domain; authed users are redirected before they
            ever see this page (RootResolver). */}
        {showSignIn ? (
          <Link className="coming-soon__signin" to="/login">
            Already have access? Sign in
          </Link>
        ) : null}
        <div className="coming-soon__meta">
          <b>dashboard.meridiananalytics.io</b>
          <br />
          Meridian Analytics, Inc.
        </div>
      </section>
    </main>
  );
}
